import React from 'react';
import { Label } from 'reactstrap';
import { Field } from 'formik';
import { RadioGroup, Radio } from 'react-radio-group';

type Props = {
  name: string,
  options: Array<{ value: string, title: string }>,
};

export default function CustomRadioGroup(props: Props) {
  const { name, options } = props;

  return (
    <Field name={name}>
      {({ field, form }) => {
        return (
          <RadioGroup
            name={name}
            selectedValue={field.value}
            onChange={v => form.setFieldValue(name, v)}
          >
            {options.map(({ value, title }) => {
              return (
                <Label key={title}>
                  <Radio value={value} />
                  <span />
                  {title}
                </Label>
              );
            })}
          </RadioGroup>
        );
      }}
    </Field>
  );
}



// WEBPACK FOOTER //
// ./src/components/Inputs/CustomRadioGroup.js